/* eslint-disable react/prop-types */
import { Checkbox, Label } from "@egaranti/components";

import { useTranslation } from "react-i18next";

import {
  PERMISSION_SECTIONS,
  isAllPermissionsSelected,
  toggleAllPermissions,
  toggleChildPermission,
  toggleSectionPermission,
} from "@/lib/employeePermissions";

// Personel ekleme ve düzenleme ekranlarında ortak kullanılır; iki ekranın yetki
// listesi elle kopyalandığında sıralama kayması yaşandığı için tek kaynağa alındı.
const PermissionsCard = ({ permissions, onChange }) => {
  const { t } = useTranslation();

  const allSelected = isAllPermissionsSelected(permissions);

  const toggleAll = () => onChange(toggleAllPermissions(permissions));

  const toggleSection = (sectionKey, action) =>
    onChange(toggleSectionPermission(permissions, sectionKey, action));

  const toggleChild = (childKey, action) =>
    onChange(toggleChildPermission(permissions, childKey, action));

  return (
    <div className="formBox">
      <div className="flex justify-between">
        <h2 className="mb-5 font-medium">
          {t("settingsPage.accessPermissions")}
        </h2>
        <div className="flex items-center gap-3">
          <Checkbox id="t" checked={allSelected} onClick={toggleAll} />
          <label htmlFor="t">{t("settingsPage.allPermissions")}</label>
        </div>
      </div>
      <div className="flex flex-col">
        {PERMISSION_SECTIONS.map((section) => (
          <div
            key={section.key}
            className="flex flex-col gap-5 border-b py-5 last:border-0"
          >
            <h2 className="font-medium text-[#111729]">
              {t(section.titleKey, section.titleFallback)}
            </h2>
            <div className="flex items-center justify-between gap-12">
              <div className="flex w-full flex-col gap-2">
                <div className="flex items-center gap-2">
                  <Checkbox
                    id={`${section.key}-g`}
                    checked={permissions[section.key]?.includes("VIEW")}
                    onClick={() => toggleSection(section.key, "VIEW")}
                  />
                  <Label
                    className="cursor-pointer"
                    htmlFor={`${section.key}-g`}
                  >
                    {t("settingsPage.viewing")}
                  </Label>
                </div>
                <p className="text-sm text-gray-500">
                  {t(section.desc1Key, section.desc1Fallback)}
                </p>
              </div>
              <div className="flex w-full flex-col gap-2">
                <div className="flex items-center gap-2">
                  <Checkbox
                    id={`${section.key}-d`}
                    checked={permissions[section.key]?.includes("EDIT")}
                    onClick={() => toggleSection(section.key, "EDIT")}
                  />
                  <Label
                    className="cursor-pointer"
                    htmlFor={`${section.key}-d`}
                  >
                    {t("settingsPage.editing")}
                  </Label>
                </div>
                <p className="text-sm text-gray-500">
                  {t(section.desc2Key, section.desc2Fallback)}
                </p>
              </div>
            </div>
            {section.children?.length ? (
              <div className="flex flex-col gap-4 rounded-lg bg-[#F9FAFC] p-4">
                {section.children.map((child) => (
                  <div
                    key={child.key}
                    className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between"
                  >
                    <span className="text-sm font-medium text-[#111729]">
                      {t(child.titleKey, child.titleFallback)}
                    </span>
                    <div className="flex items-center gap-6">
                      <div className="flex items-center gap-2">
                        <Checkbox
                          id={`${child.key}-g`}
                          checked={permissions[child.key]?.includes("VIEW")}
                          onClick={() => toggleChild(child.key, "VIEW")}
                        />
                        <Label
                          className="cursor-pointer"
                          htmlFor={`${child.key}-g`}
                        >
                          {t("settingsPage.viewing")}
                        </Label>
                      </div>
                      <div className="flex items-center gap-2">
                        <Checkbox
                          id={`${child.key}-d`}
                          checked={permissions[child.key]?.includes("EDIT")}
                          onClick={() => toggleChild(child.key, "EDIT")}
                        />
                        <Label
                          className="cursor-pointer"
                          htmlFor={`${child.key}-d`}
                        >
                          {t("settingsPage.editing")}
                        </Label>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PermissionsCard;
